var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({staticClass:"order-chip"},'v-chip',_vm.variation,false),[_c('span',{staticClass:"order-chip__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }